import { useCallback } from 'react';
import { gql, useMutation } from '@apollo/client';

const query = gql`
  mutation SuspendLogin($idnumber: String!, $reason: String!) {
    suspend(idnumber: $idnumber, reason: $reason)
  }
`;

interface Args {
  idnumber: string;
  reason: string;
}

type HookReturns = [
  (idnumber: string, reason: string) => Promise<void>,
  { loading: boolean },
];

export default function useSuspendLogin(): HookReturns {
  const [mutate, { loading, error }] = useMutation<unknown, Args>(query, {
    refetchQueries: 'all',
  });
  if (error != null) throw error;

  const action = useCallback(
    async (idnumber: string, reason: string): Promise<void> => {
      await mutate({ variables: { idnumber, reason } });
    },
    [mutate]
  );

  return [action, { loading }];
}
